import styled from 'styled-components';
import rem from 'polished/lib/helpers/rem';
import toColorString from 'polished/lib/color/toColorString';

import color from '@decisiv/design-tokens/lib/color';
import spacing from '@decisiv/design-tokens/lib/spacing';

import Flex from '@decisiv/ui-components/lib/components/Flex';

export const Row = styled(Flex)`
  align-items: center;
  gap: ${rem(spacing.base * 1)};
  margin-top: ${rem(spacing.base * 1.5)};
`;

export const HiddenFileInput = styled.input`
  display: none;
`;

export const FileCard = styled(Flex)<{ hasError?: boolean }>`
  flex-direction: row;
  align-items: center;
  padding: ${rem(spacing.base)};
  border: 1px solid
    ${({ hasError }) =>
      hasError
        ? toColorString(color.status.warning.medium)
        : toColorString(color.opacity.charcoal15)};
  border-radius: ${rem(spacing.base * 0.5)};
  margin-top: ${rem(spacing.base)};
  gap: ${rem(spacing.base)};
`;

export const FileErrorRow = styled(Flex)`
  flex-direction: row;
  align-items: center;
  gap: ${rem(spacing.base * 0.5)};
  margin-top: ${rem(spacing.base * 0.5)};
`;
